import React, { Component } from 'react'
import { Button, Card, Col, Form, Row, notification, Icon, Popconfirm } from 'antd'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import EditEventDrawer from './EditEventDrawer'

// Unified Imports
import {
  formItemLayout,
  DefaultTablePagination,
  DisplayDate
} from '../../components/_utils/appUtils'
import {
  createEventFxn,
  listAllEventsAction,
  deleteEventFxn
} from './actions'

class ManageEvents extends Component {
  constructor(props) {
    super(props)
    this.state = {
      totalEvents: 0,
      filters: {},
      editDrawerVisible: false,
      selectedEvent: null
    }
    this.table = React.createRef()
  }

  // ==========================================
  // TABLE & API LOGIC
  // ==========================================
  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      try {
        let filters = {
          ...params,
          sortField: params.sortField || '_id',
          sortOrder: params.sortOrder ? Number(params.sortOrder) : -1,
          regExFilters: ['eventName']
        }

        let data = await this.props.dispatch(listAllEventsAction(filters))

        this.setState({
          totalEvents: data.total || 0,
          filters
        })
        resolve(data)

      } catch (error) {
        notification.error({ message: 'Error fetching events' })
        resolve({ data: [], total: 0 })
      }
    })
  }

  reload = () => {
    if (this.table.current) {
      this.table.current.reload()
    }
  }

  deleteEvent = async (id) => {
    try {
      let resp = await this.props.dispatch(deleteEventFxn(id))
      if (resp && resp.success) {
        this.reload()
      }
    } catch (error) {
      notification.error({ message: 'Server error encountered while deleting event' })
    }
  }

  // ==========================================
  // FORM SUBMIT LOGIC
  // ==========================================
  handleSubmit = e => {
    e.preventDefault()

    this.props.form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let response = await this.props.dispatch(createEventFxn(valData))
        if (response && response.success) {
          this.props.form.resetFields()
          this.reload() // 🌟 Instantly reloads the table right next to it!
        } else {
          notification.error({
            message: (response && response.message) || 'Submission failed'
          })
        }
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    // Form Schema
    const inputSchema = {
      fields: [
        { label: 'Event Name', key: 'eventName', required: true, type: 'text', placeholder: 'Enter event name', span: 24 },
        { label: 'Event Date', key: 'eventDate', required: true, type: 'date', placeholder: 'Select event date', span: 24 }
      ]
    }

    const verticalFormLayout = {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    }

    // Table Columns
    const columns = [
      {
        title: 'Event Name',
        dataIndex: 'eventName',
        searchTextName: 'eventName',
        render: (text) => text || 'N/A'
      },
      {
        title: 'Event Date',
        dataIndex: 'eventDate',
        width: 180,
        render: (d) => DisplayDate(d)
      },
      {
        title: 'Actions',
        key: 'actions',
        width: 120,
        fixed: 'right',
        align: 'center',
        render: (text, record) => {
          return (
            <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
              <a
                className='btn btn-default round btn-sm'
                onClick={() => this.setState({ editDrawerVisible: true, selectedEvent: record })}>
                <Icon type='edit' /> Edit
              </a>
              <Popconfirm
                placement='topLeft'
                title={`Are you sure you want to delete this event?`}
                onConfirm={() => this.deleteEvent(record._id)}
                okText='Yes'
                cancelText='No'
              >
                <a className='btn btn-default round btn-sm'>
                  <Icon type='delete' /> Delete
                </a>
              </Popconfirm>
            </div>
          )
        }
      }
    ]

    return (
      <PageHeaderWrapper title="Manage Events">

        {/* 🌟 Top Aligned Row holding both Form and Table */}
        <Row gutter={24} type='flex' align='top'>
          <Col span={15}>
            <Card title={`Events List (${this.state.totalEvents})`} bordered={false}>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                pagination={DefaultTablePagination({}, 50)}
                extraProps={{ scroll: { x: true } }}
              />
            </Card>
          </Col>

          <Col span={9}>
            <Card title='Add New Event' bordered={false}>
              <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'}>
                <Row gutter={16}>
                  {inputSchema.fields.map((item, key) => (
                    <Col span={item.span || 24} key={key}>
                      <GetEachFormFields
                        getFieldDecorator={getFieldDecorator}
                        item={item}
                        formItemLayout={verticalFormLayout}
                      />
                    </Col>
                  ))}

                  <Col span={24} style={{ textAlign: 'left', marginTop: '16px' }}>
                    <Form.Item style={{ marginBottom: 0 }}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        style={{ width: '100%', backgroundColor: '#001529', borderColor: '#001529' }}
                      >
                        SUBMIT EVENT
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>


        </Row>

        {/* DRAWER COMPONENT */}
        {this.state.editDrawerVisible && (
          <EditEventDrawer
            visible={this.state.editDrawerVisible}
            event={this.state.selectedEvent}
            callBackReload={() => this.reload()}
            onClose={() => this.setState({ editDrawerVisible: false, selectedEvent: null })}
            callback={() => this.reload()}
          />
        )}

      </PageHeaderWrapper>
    )
  }
}

const WrappedForm = Form.create()(ManageEvents)
export default connect()(WrappedForm)
